export var ClientsStatus;
(function (ClientsStatus) {
    ClientsStatus[ClientsStatus["Initial"] = 0] = "Initial";
    ClientsStatus[ClientsStatus["Cleared"] = 1] = "Cleared";
    ClientsStatus[ClientsStatus["ClearedRetrievedClient"] = 2] = "ClearedRetrievedClient";
    ClientsStatus[ClientsStatus["Fetching"] = 3] = "Fetching";
    ClientsStatus[ClientsStatus["FetchSuccess"] = 4] = "FetchSuccess";
    ClientsStatus[ClientsStatus["FetchingAll"] = 5] = "FetchingAll";
    ClientsStatus[ClientsStatus["FetchAllSuccess"] = 6] = "FetchAllSuccess";
    ClientsStatus[ClientsStatus["Getting"] = 7] = "Getting";
    ClientsStatus[ClientsStatus["GetSuccess"] = 8] = "GetSuccess";
    ClientsStatus[ClientsStatus["Saving"] = 9] = "Saving";
    ClientsStatus[ClientsStatus["SaveSuccess"] = 10] = "SaveSuccess";
    ClientsStatus[ClientsStatus["SavingAuthorizedContacts"] = 11] = "SavingAuthorizedContacts";
    ClientsStatus[ClientsStatus["SaveAuthorizedContactsSuccess"] = 12] = "SaveAuthorizedContactsSuccess";
    ClientsStatus[ClientsStatus["Deleting"] = 13] = "Deleting";
    ClientsStatus[ClientsStatus["DeleteSuccess"] = 14] = "DeleteSuccess";
    ClientsStatus[ClientsStatus["LogicalDeleting"] = 15] = "LogicalDeleting";
    ClientsStatus[ClientsStatus["LogicalDeleteSuccess"] = 16] = "LogicalDeleteSuccess";
    ClientsStatus[ClientsStatus["Error"] = 17] = "Error";
})(ClientsStatus || (ClientsStatus = {}));
